import { lazy, Suspense, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// types
import { BuyerChatRespLazy_viewer as Viewer } from './__generated__/BuyerChatRespLazy_viewer.graphql';

const LazyComponent = lazy(() => import(/* webpackChunkName: "BuyerChatResp" */ './BuyerChatResp'));

type Props = {
    viewer: Viewer;
    isInitiallyMinimized: boolean;
    draftedMessage?: string | null;
};

export const BuyerChatRespLazyComponent: FC<Props> = props =>
    props.viewer ? (
        <Suspense fallback="">
            <LazyComponent {...props} />
        </Suspense>
    ) : null;

export const BuyerChatRespLazy = createFragmentContainer(BuyerChatRespLazyComponent, {
    viewer: graphql`
        fragment BuyerChatRespLazy_viewer on Viewer {
            ...BuyerChatResp_viewer
        }
    `,
});
